import React from 'react';
import { User } from 'lucide-react';

/**
 * Admin login form component
 */
const AdminLogin = ({ adminEmail, setAdminEmail, adminPassword, setAdminPassword, handleAdminLogin }) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 to-blue-900 flex items-center justify-center py-12 px-4">
    <div className="max-w-md w-full">
      <div className="bg-white rounded-3xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <div className="bg-gradient-to-r from-purple-500 to-blue-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
            <User className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
            Admin Portal
          </h2>
          <p className="text-gray-600 mt-2">Secure access to order management</p>
        </div>
        
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
            <input
              type="email"
              placeholder="admin@bookify.com"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
            />
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className="w-full p-4 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-200 focus:border-purple-400 transition-all"
            />
          </div>
          
          <button
            onClick={handleAdminLogin}
            className="w-full bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white font-bold py-4 rounded-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            Access Dashboard
          </button>
          
          <div className="bg-gray-50 p-4 rounded-xl">
            <p className="text-sm text-gray-600 text-center">
              <span className="font-semibold">Demo Credentials:</span><br />
              Email: admin@bookify.com<br />
              Password: admin123
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AdminLogin;
